import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import { CostEffect, parseCostEffect } from "./util/cost"

export class OrderDryRunBuyingPowerEffect {
  currentBuyingPower = 0
  currentBuyingPowerEffect = CostEffect.NoCost
  newBuyingPower = 0
  newBuyingPowerEffect = CostEffect.NoCost
  changeInBuyingPower = 0
  changeInBuyingPowerEffect = CostEffect.NoCost
  impact = 0
  effect = CostEffect.NoCost
}

export const ORDER_DRY_RUN_BUYING_POWER_EFFECT_DESER: SchemaDeSer<OrderDryRunBuyingPowerEffect> =
  new SchemaDeSerBuilder(OrderDryRunBuyingPowerEffect)
    .ofFloat("currentBuyingPower", "current-buying-power")
    .ofCustomEnum(
      "currentBuyingPowerEffect",
      "current-buying-power-effect",
      parseCostEffect
    )
    .ofFloat("newBuyingPower", "new-buying-power")
    .ofCustomEnum(
      "newBuyingPowerEffect",
      "new-buying-power-effect",
      parseCostEffect
    )
    .ofFloat("changeInBuyingPower", "change-in-buying-power")
    .ofCustomEnum(
      "changeInBuyingPowerEffect",
      "change-in-buying-power-effect",
      parseCostEffect
    )
    .ofFloat("impact")
    .ofCustomEnum("effect", "effect", parseCostEffect)
    .toDeSer()

export class OrderDryRunFeeCalculation {
  totalFees = 0
  totalFeesEffect = CostEffect.NoCost
  commission = 0
  commissionEffect = CostEffect.NoCost
  regulatoryFees = 0
  regulatoryFeesEffect = CostEffect.NoCost
}

export const ORDER_DRY_RUN_FEE_CALCULATION_DESER: SchemaDeSer<OrderDryRunFeeCalculation> =
  new SchemaDeSerBuilder(OrderDryRunFeeCalculation)
    .ofFloat("totalFees", "total-fees")
    .ofCustomEnum("totalFeesEffect", "total-fees-effect", parseCostEffect)
    .ofFloat("commission")
    .ofCustomEnum("commissionEffect", "commission-effect", parseCostEffect)
    .ofFloat("regulatoryFees", "regulatory-fees")
    .ofCustomEnum(
      "regulatoryFeesEffect",
      "regulatory-fees-effect",
      parseCostEffect
    )
    .toDeSer()

export class OrderDryRunOrder {
  size = 0
  orderType = ""
  value = 0
  valueEffect = CostEffect.NoCost
}

export const ORDER_DRY_RUN_ORDER_DESER: SchemaDeSer<OrderDryRunOrder> =
  new SchemaDeSerBuilder(OrderDryRunOrder)
    .ofFloat("size")
    .ofString("orderType", "order-type")
    .ofFloat("value")
    .ofCustomEnum("valueEffect", "value-effect", parseCostEffect)
    .toDeSer()

export class OrderDryRunResponse {
  order = new OrderDryRunOrder()
  buyingPowerEffect = new OrderDryRunBuyingPowerEffect()
  feeCalculation = new OrderDryRunFeeCalculation()
}

export const ORDER_DRY_RUN_RESPONSE_DESER: SchemaDeSer<OrderDryRunResponse> =
  new SchemaDeSerBuilder(OrderDryRunResponse)
    .ofNested("order", ORDER_DRY_RUN_ORDER_DESER, OrderDryRunOrder)
    .ofNested(
      "buyingPowerEffect",
      ORDER_DRY_RUN_BUYING_POWER_EFFECT_DESER,
      OrderDryRunBuyingPowerEffect,
      "buying-power-effect"
    )
    .ofNested(
      "feeCalculation",
      ORDER_DRY_RUN_FEE_CALCULATION_DESER,
      OrderDryRunFeeCalculation,
      "fee-calculation"
    )
    .toDeSer()
